import invariant from 'invariant';
import type { Store } from 'redux';
import configureStore from 'Store';

import { persistStore } from 'Lib/persist';
import type { Action, GlobalStateType } from 'Lib/reduxType';

import getDehydratedState from './getDehydratedState';

let storeInstance: Store;

export function initializeInstance(): Store<GlobalStateType, Action> {
  invariant(!storeInstance, 'Store already initialized!');

  const dehydratedState = getDehydratedState();

  let initializePersist;
  storeInstance = configureStore(dehydratedState, {
    onReplaceReducer() {
      initializePersist();
    },
  });
  ({ initializePersist } = persistStore(storeInstance));
  initializePersist();

  if (__DEVELOPMENT__) {
    window.store = storeInstance;
  }
  return storeInstance;
}

export function getInstance(): Store<GlobalStateType, Action> {
  invariant(storeInstance, 'Store not initialized!');

  return storeInstance;
}

export function setInstance(instance: Store<GlobalStateType, Action>) {
  if (__TEST__) {
    storeInstance = instance;
  }
}
